import React from 'react'
import PropTypes from 'prop-types'
import SVG from 'react-svg-inline'

import NavClients from '../components/NavClients'
import Footer from '../components/Footer'
import Detail from 'components/Detail'
import PrevNext from 'components/PrevNext'
import allClients from 'utils/clients'
import PageNotFound from '../pages/PageNotFound'

export default class Client extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        slug: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }

  state = {
    slug: this.props.match.params.slug,
    client: {},
    component: () => null,
    name: '',
    color: '',
    description: '',
    duration: '',
    location: '',
    role: '',
    scope: '',
    stack: '',
    website: '',
    appstore: '',
    playstore: '',
    isLoading: 'fadeInUp',
  }

  componentWillMount() {
    this.updateClient(this.props.match.params.slug)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isLoading: 'fadeOutDown' })
    setTimeout(() => this.updateClient(nextProps.match.params.slug), 500)
  }

  updateClient = (slug) => {
    const client = allClients.find(c => c.slug === slug)

    if (!client) {
      return this.setState({ client })
    }

    this.setState({
      component: client.loadComponent,
      name: client.name,
      color: client.color,
      order: client.order,
      logo: client.logo,
      description: client.description,
      duration: client.duration,
      location: client.location,
      role: client.role,
      scope: client.scope,
      stack: client.stack,
      website: client.website,
      appstore: client.appstore,
      playstore: client.playstore,
      isLoading: 'fadeInUp',
    })

    document.title = `${client.name} | Sergi Miral`
  }

  renderClient = () => {
    const {
      color,
      logo,
      duration,
      location,
      scope,
      role,
      stack,
      website,
      playstore,
      appstore,
      isLoading,
    } = this.state

    return (
      <div>
      <NavClients />
      <div className={isLoading}>
        <section className="client-cover container">
          <SVG svg={logo} />
        </section>
        <div className="client-overview" style={{color: color }}>
          <section className="container">
            <div className="col-1-of-12" />
            <div className="col-5-of-12 overview">
              <h3>> overview:</h3>
              <p>{this.state.description}</p>
            </div>
            <div className="col-5-of-12 details">
              <h3>> details:</h3>
              <ul>
                {duration && <Detail title="Duration" value={duration} text />}
                {location && <Detail title="Location" value={location} text />}
                {role && <Detail title="Role" value={role} text />}
                {scope && <Detail title="Scope" value={scope} text />}
                {stack && <Detail title="Stack" value={stack} text />}
                {website && <Detail title="Website" value={website} link />}
                {appstore && <Detail title="App Store" value={appstore} btn />}
                {playstore &&
                  <Detail title="Play Store" value={playstore} btn />}
              </ul>
            </div>
          </section>
        </div>
        <div>
          {this.state.component()}
        </div>
        <PrevNext allClients={allClients} clientId={this.state.order} />
      </div>
      <Footer />
    </div>

    )
  }

  render() {
    return this.state.client ? this.renderClient() : <PageNotFound />
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/Client.js